import { render, staticRenderFns } from "./kitchenDisplay.vue?vue&type=template&id=3fa99e30&"
import script from "./kitchenDisplay.vue?vue&type=script&lang=js&"
export * from "./kitchenDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports